const state = {
  merchant: {},
  // MERCHANT MODEL
  // {
  //   id: '',
  //   user_role: '',
  //   name: '',
  //   legal_merchant_name: '',
  //   legal_entity_type: '',
  //   logo: '',
  //   plan: '',
  //   slug: '',
  //   email: '',
  //   website: '',
  //   about: '',
  //   description: '',
  //   address: '',
  //   created_at: '',
  //   updated_at: '',
  //   account_owner: {
  //     id: '',
  //     name: '',
  //     email: '',
  //     phone: '',
  //     created_at: '',
  //     updated_at: '',
  //   },
  //   payment_method: {
  //     type: '',
  //     brand: '',
  //     last4: '',
  //   },
  //   business_address: {
  //     country: {
  //       country: '',
  //       code: '',
  //     },
  //     city: '',
  //     line: '',
  //     postal_code: '',
  //     state: '',
  //   },
  //   messaging_platforms: {
  //     whatsapp: {
  //       phone: '',
  //     },
  //   },
  //   unread_conversations: {
  //     all_unread: 0,
  //     user_unread: [],
  //   },
  //   extra_features: [],
  // },

  // facebookRecipients: {
  //   data: [
  //     {
  //       id: 0,
  //       email: '',
  //       name: '',
  //     },
  //   ],
  //   paging: {
  //     previous: true,
  //     next: true,
  //     cursors: {
  //       before: '',
  //       after: '',
  //     },
  //   },
  // },
  // foundFacebookRecipients: {
  //   data: [
  //     {
  //       id: 0,
  //       email: '',
  //       name: '',
  //     },
  //   ],
  // },
  analytics: {
    date_points: [0],
    contacts: {
      total: 0,
      all: [0],
      new: [0],
    },
    subscribers: {
      total: 0,
      all: [0],
      subscribed: [0],
      unsubscribed: [0],
    },
    messages: {
      total_inbound: 0,
      total_outbound: 0,
      total_conversations: 0,
      inbound: [0],
      outbound: [0],
      conversations: [0],
    },
    message_responses: {
      average_resolution_time: 0,
      average_first_reply_time: 0,
      total_first_replies: {
        '0-1': 0,
        '1-8': 0,
        '8-24': 0,
        '>24': 0,
      },
    },
    sent_template_messages: {
      total: 0,
      sent: [0],
      failed: [0],
    },
    contact_activities: {
      daily_contacted: [0],
    },
    automation: {
      all_interactions: [0],
      unique_interactions: [0],
    },
    template_messages: [],
    contact_lists: [],
    keywords: [],
  },
  permissionRoles: {
    manage_settings: ['admin'],
    manage_automation: ['admin'],
    manage_contacts: ['admin'],
    view_contacts: ['admin'],
    view_analytics: ['admin'],
    manage_invoices: ['admin'],
    view_invoices: ['admin'],
    manage_lists: ['admin'],
    manage_template_messages: ['admin'],
    send_notifications: ['admin'],
  },
  settings: {
    available: true,
    timezone: 'UTC',
  },
  availabilities: [],
  appKey: {},
  merchantList: [],
  members: [],
  taxList: [],
  subscriptionsList: [],
  membersAndInvitations: [],
  membersMeta: {},
  merchantName: '',
  merchantLogo: '',
  whatsappPhoneNumber: '',
  subscriptionsListReloaded: false,
  planSubscriptionUpdated: false,
  loadingMerchantList: false,
  merchantLoaded: false,
  permissionRolesLoaded: false,
  loadingMembers: true,
  loadingData: true,
  loadingCurrencies: true,
  loadingTaxes: true,
  merchantUpdated: false,
  successEmailUpdate: false,
  appKeyLoaded: false,
  appKeyUpdated: false,
  availabilityUpdated: false,
  availabilityTimesUpdated: false,
  successPasswordUpdate: false,
  invitationSent: false,
  currencyChanged: false,
  invitationDeleted: false,
  memberRoleChanged: false,
  memberTeamsChanged: false,
  memberDeleted: false,
  permissionRolesUpdated: false,
  taxSaved: false,
  taxDeleted: false,
  stripeSuccessConnect: false,
  stripeSuccessDisconnect: false,
  merchantAvailability: {},
  merchantHasPaymentProvider: false,
  merchantHasWhatsapp: false,
  // merchantHasFacebook: false,
  merchantHasMessagingPlatform: false,
  fetchingBlocked: false,
  blocklist: {},
  apiError: {},
};

export default state;
